import React, { useState } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Switch,
  Text,
  Divider,
} from '@chakra-ui/react';
import { useAuth } from '../../hooks/auth';
import api from '../../services/api';

const Settings: React.FC = () => {
  const { user, updateUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle2FA = async (enabled: boolean) => {
    setIsLoading(true);
    try {
      await api.patch('/users/settings', { two_fa_enabled: enabled });
      updateUser({ ...user, two_fa_enabled: enabled });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box maxW="600px" mx="auto" mt={10} px={6}>
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        Configurações
      </Text>
      <Divider mb={6} />
      <Text fontSize="lg" fontWeight="semibold" mb={4}>
        Segurança
      </Text>
      <FormControl>
        <Flex alignItems="center" justifyContent="space-between">
          <Box>
            <FormLabel mb={0} fontWeight="medium">
              Autenticação em duas etapas
            </FormLabel>
            <Text fontSize="sm" color="gray.500">
              Ao ativar, um código será enviado ao seu e-mail a cada novo login.
            </Text>
          </Box>
          <Switch
            size="lg"
            isChecked={user?.two_fa_enabled ?? false}
            onChange={e => handleToggle2FA(e.target.checked)}
            isDisabled={isLoading}
            colorScheme="blue"
          />
        </Flex>
      </FormControl>
    </Box>
  );
};

export default Settings;
